import React, { useState } from "react";
import { Glyphicon } from "react-bootstrap";
import { Button } from "./Button";
import { v4 as uuidv4 } from "uuid";
import { DropdownOptions } from "./dropdown/Dropdown";
import { OverlayStyle, OverlayTrigger } from "./OverlayTrigger";
import { useStylesHook } from "./hooks/useStylesHook";
import { classNames } from "./utils/classNames";
export var DropdownButton = function (_a) {
    var label = _a.label, items = _a.items, _b = _a.direction, direction = _b === void 0 ? "left" : _b, _c = _a.type, type = _c === void 0 ? "default" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, container = _a.container, dataTestId = _a.dataTestId, id = _a.id, iconOnly = _a.iconOnly;
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var classes = useDropdownClasses();
    var labelId = uuidv4();
    var menuDirection = direction === "left" ? "bottom-start" : "bottom-end";
    var labelContent = iconOnly ? (React.createElement("span", null,
        React.createElement("span", { className: "sr-only" }, label),
        React.createElement(Glyphicon, { glyph: "option-vertical" }))) : (React.createElement(React.Fragment, null,
        label,
        " ",
        React.createElement("span", { className: classNames("glyphicon-pro glyphicon-pro-chevron-down", classes.icon) })));
    var button = (React.createElement(Button, { label: labelContent, id: id || labelId, type: type, disabled: disabled, stopPropagation: false, onClick: function () { return setOpen(!open); }, className: open ? "dropdown-open" : "" }));
    var options = items ? (React.createElement(DropdownOptions, { id: labelId, options: items })) : (React.createElement("span", null, "nothing to see here "));
    return (React.createElement(OverlayTrigger, { overlayTrigger: button, overlayContent: options, overlayStyle: OverlayStyle.Dropdown, placement: menuDirection, onOutsideClickDeactivate: function () { return setOpen(false); }, onClose: function () { return setOpen(false); }, container: container, dataTestId: dataTestId }));
};
var useDropdownClasses = function () {
    return useStylesHook({
        icon: {
            marginLeft: 2,
            fontSize: 13,
        },
    });
};
